import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FiX, FiTruck } from 'react-icons/fi';

const Overlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 2rem;
`;

const Modal = styled(motion.div)`
  background: linear-gradient(135deg, #1a1a3e 0%, #2d2d5f 100%);
  border-radius: 16px;
  width: 100%;
  max-width: 800px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
`;

const Header = styled.div`
  padding: 2rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;

  h2 {
    color: #fff;
    font-size: 1.8rem;
    font-weight: 700;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 0.5rem;

    .icon {
      color: #4facfe;
    }
  }

  .close-btn {
    background: rgba(255, 255, 255, 0.1);
    border: none;
    border-radius: 8px;
    padding: 0.5rem;
    color: #fff;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.2);
    }
  }
`;

const Content = styled.div`
  padding: 2rem;
  text-align: center;
  color: #a0a0a0;

  .placeholder-icon {
    font-size: 4rem;
    color: #4facfe;
    margin-bottom: 1rem;
  }

  .placeholder-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: #fff;
    margin-bottom: 1rem;
  }

  .placeholder-description {
    line-height: 1.6;
    max-width: 500px;
    margin: 0 auto;
  }
`;

const IssuerDeliveryCenter = ({ onClose }) => {
  return (
    <Overlay
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <Modal
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
      >
        <Header>
          <h2>
            <FiTruck className="icon" />
            Delivery Management Center
          </h2>
          <button className="close-btn" onClick={onClose}>
            <FiX />
          </button>
        </Header>

        <Content>
          <FiTruck className="placeholder-icon" />
          <div className="placeholder-title">Physical Delivery Hub</div>
          <div className="placeholder-description">
            This center will provide comprehensive delivery management capabilities for authorized issuers.
            Features will include:
            <br /><br />
            • Physical delivery request processing
            <br />
            • Logistics coordination and tracking
            <br />
            • Secure transport arrangements
            <br />
            • Chain of custody documentation
            <br />
            • Insurance and security protocols
            <br />
            • Real-time delivery status updates
            <br /><br />
            This functionality will be implemented in the next development phase.
          </div>
        </Content>
      </Modal>
    </Overlay>
  );
};

export default IssuerDeliveryCenter; 